import axios from "axios";

export const CONFIGURATION_GET_GOOGLE_MAPS_KEY = "CONFIGURATION_GET_GOOGLE_MAPS_KEY";

export const getGoogleMapsKey = (idArt) => (dispatch, getState) => {
  const artIdNumber = Number(idArt);
  if (!Number.isInteger(artIdNumber) || artIdNumber <= 0) {
    return Promise.reject(new Error("No se encontro la ART"));
  }

  // si ya tiene key cargada no la recarga
  const artKey = String(artIdNumber);
  const stored = getState().configuration?.googleMapsKeys?.[artKey];
  if (typeof stored?.data === "string" || stored?.isFetching) {
    return Promise.resolve({ value: { data: stored?.data || "" } });
  }

  return dispatch({
    type: CONFIGURATION_GET_GOOGLE_MAPS_KEY,
    meta: { idArt: artKey },
    payload: axios
      .get(`configuration/googleMapsKey?idArt=${idArt}`)
      .then((response) => {
        const serverKey = response.data.trim();
        return { data: serverKey || CONFIG.googleMapsKey || "", idArt: artKey };
      })
      .catch((error) => Promise.reject(error)),
  });
};
